import axios from 'axios';
import { goLogin } from '.';
import { getApiOrigin } from './origin';

const request = axios.create();

request.interceptors.request.use(config => {
  const token = window.sessionStorage.getItem('auth_token');
  return {
    ...config,
    baseURL: process.env.NODE_ENV === 'development' ? '/api' : getApiOrigin(),
    headers: { Authorization: config.headers.Authorization || token },
    data: config.data
  };
});

request.interceptors.response.use(response => {
  if (response.status === 200 && response.data) {
    const { ret } = response.data;
    if (ret === 2001) {
      window.sessionStorage.clear();
      goLogin();
    }
  }
  return response;
});

export default request;
